import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DeclareOrder } from "../../pages/Price/models/declareOrder";
import { EBaseUrl } from "../models/enums/env.enum";
import { api } from "../utils";

const initialState: any = {
  countData: {},
  priceData: "",
  declareOrderData: {},
};

const name = "Order";

export const getCount = createAsyncThunk(`${name}/getCount`, async () => {
  return api({
    method: "GET",
    url: `${EBaseUrl.envLetter}/Order/Count`,
  });
});

export const getPrice = createAsyncThunk(
  `${name}/getPrice`,
  async ({
    countryID,
    giftCardIDs = null,
    postCardID = "",
  }: {
    countryID: number;
    giftCardIDs: string[] | null;
    postCardID: number | string;
  }) => {
    return api({
      method: "GET",
      url: `${EBaseUrl.envLetter}/Order/Price?countryID=${countryID}&giftCardIDs=${giftCardIDs}&postCardID=${postCardID}`,
    });
  }
);

export const declareOrder = createAsyncThunk(
  `${name}/declareOrder`,
  async (data: DeclareOrder) => {
    return api({
      method: "Post",
      body: data,
      url: `${EBaseUrl.envLetter}/Order/Declare`,
    });
  }
);

const orderSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCount.fulfilled, (state, { payload }) => {
      state.countData = payload;
    });
    builder.addCase(getPrice.fulfilled, (state, { payload }) => {
      state.priceData = payload;
    });
    builder.addCase(declareOrder.fulfilled, (state, { payload }) => {
      state.declareOrderData = payload;
    });
  },
});

export const selectCount = (state: any) => state.order.countData?.count;
export const selectOrderPrice = (state: any) => state.order.priceData;

export default orderSlice.reducer;
